import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "pcgoodslist-template1",
    style: {
      backgroundColor: _vm.formData.bgColor
    }
  }, [_c("div", {
    staticClass: "body"
  }, [_c("div", [_vm.formData.titles[_vm.defaultLangId] ? _c("div", {
    staticClass: "title",
    style: {
      color: _vm.formData.titleColor,
      fontSize: _vm.formData.titleFontSize + "px",
      paddingTop: (_vm.formData.pcTitlePaddingTop || 0) + "px",
      paddingBottom: (_vm.formData.pcTitlePadingBottom || 0) + "px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.titles[_vm.defaultLangId]) + " ")]) : _vm._e(), _vm.moduleData && _vm.moduleData.length > 0 ? _c("div", {
    staticClass: "banner_bg",
    style: {
      padding: "0px " + (_vm.formData.pcHorizontalPadding || 0) + "px"
    }
  }, _vm._l(_vm.moduleData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "bg_wrapper",
      style: {
        marginBottom: (_vm.formData.pcBannerVerticalSpace || 0) + "px"
      }
    }, _vm._l(item, function (item2, i2) {
      return _c("div", {
        key: i2,
        staticClass: "div_img_bg",
        style: {
          width: item2.outWidth,
          height: item2.height,
          margin: "0 ".concat(item2.padding)
        },
        attrs: {
          "data-index": i2
        }
      }, [_c("div", {
        staticClass: "div_content_bg"
      }, [_c("YYImage", {
        staticClass: "div_banner",
        style: item.style,
        attrs: {
          fit: "cover",
          lazy: false,
          src: _vm.imgHost + item2.imgpath
        },
        on: {
          click: function click($event) {
            return _vm.goToPage(item.link);
          }
        }
      }), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()], 1), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()]);
    }), 0);
  }), 0) : _vm._e(), _vm.formData.productList && _vm.formData.productList.length > 0 ? _c("ProductListSlider", {
    attrs: {
      list: _vm.formData.productList
    }
  }) : _vm._e()], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };